<template>
  <div class="hammer-up">
    <div class="hammer" ref="hammer"  ><!-- v-bind:style="currentStyle" -->
        <!-- <v-touch ref="hammerIn" v-on:pinchend="hammerUp" v-on:panend="hammerUp" v-on:pinch="hammerPan" v-on:pan="hammerPan" v-on:tap="toggle" tag="canvas"  id="theCanvas" ></v-touch> -->
        <canvas ref="hammerIn"  tag="canvas"  id="theCanvas" ></canvas>
    </div>
    <div class="pdf-button" v-show="isButton">
    <el-pagination @current-change="handleCurrentChange" v-bind:current-page="currPageNumber" :page-size="1"  layout="prev, pager, next" v-bind:total="doc.numPages"></el-pagination>
    </div>
  </div>
</template>

<script>
var pdfjsLib = require('pdfjs-dist');
pdfjsLib.PDFJS.workerSrc = 'https://apps.terasmm.it/pdf.worker.js';
var vw = (window.innerWidth || document.documentElement.clientWidth)
var vh = (window.innerHeight || document.documentElement.clientHeight)

export default {
  name: 'pdf',
  props: ['pdfPath'],
  data () {
    return {
      isButton: false,
        loading: true,
        doc: {},
        currPageNumber: 1,  
        viewportSet: 0,
        viewport: null,

        currentScale: null,
        currentDeltaX: null,
        currentDeltaY: null,
        adjustScale:1,
        adjustDeltaX:0,
        adjustDeltaY:0,
        currentStyle:'width:100%;position:abolute; transform-origin: left top;transform:scale(1) '
    }
  },
  created () { 
    console.log("PDF CON "+this.pdfPath)
    this.loadPdf(this.pdfPath)
    
  },
  watch: {
   pdfPath: function (pdfPath) {
       console.log("LOADING IS CHENGIN")
    if(pdfPath!='')
        this.loadPdf(pdfPath+'?random='+Math.floor((Math.random() * 100000000) + 1))
    }
  },
  mounted: function () {
    //this.larghezza = parseInt(this.$refs.app.clientWidth);
    window.addEventListener('resize', this.handleResize)
    //window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
    //window.removeEventListener('scroll', this.handleScroll)
  },


  methods: {
    toggle(){
      console.log("TOGGLE "+this.isButton)
      this.isButton = !this.isButton
    },
      loadPdf(pdfPath){
        this.loading = true    
        /*
        this.pdfPath=''
        if(this.$teras.platform != 'desktop')
          this.pdfPath = this.$root.urlsite
        this.pdfPath = this.pdfPath+"api/vue/pdf/file/" + this.$route.params.farmaco
        */
        var parent = this
        this.axios.get(pdfPath,{responseType: 'blob'})
        .then(function (response) {
          console.log("DATA SIZE: "+response.data.size);
          if(response.data.size>0){
            parent.fetchData(window.URL.createObjectURL(response.data))
          }
        })
        .catch(function (error) {
          parent.$notify.error({title: 'Errore',message: error.response})
        })
 
     }, 
    fetchData (docPdf) {
      this.currPageNumber = 1    
      var parent = this
      pdfjsLib.getDocument(docPdf).promise.then(function (pdfDocument) {
          console.log("FUNZIONA!")
        parent.doc = pdfDocument;
        return parent.openPage(parent.doc, 1, parent.zoom);
      }).catch(function (reason) {
        console.error('Error: ' + reason);
        parent.$notify.error({title: 'Errore PDFjs',message: reason })
      })
    },
    openPage(pdfFile,pageNumber, zoom){
        var parent = this
        pdfFile.getPage(1).then(function (page) {
            var scale = 1;
            var viewport = page.getViewport(scale);

            var vw = viewport.width
            var vh = viewport.height 
            console.log(vw+" v "+vh)
            var Hvw = parent.$el.clientWidth-24
           
            var Hvh = parent.$el.clientHeight-4
            console.log(parent.$el)
            console.log(Hvw+" h "+Hvh) 
            var minScale = Hvw/vw /* (vh/Hvh > vw/Hvw) ? Hvw/vw : Hvh/vh */
            console.log((vh/Hvh > vw/Hvw)+' minscale ' +minScale)

            viewport = page.getViewport(minScale);
            

            // Prepare canvas using PDF page dimensions.
            var canvas = document.getElementById('theCanvas');
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            //console.log(page.getViewport(canvas.width / page.getViewport(1).width))
            // Render PDF page into canvas context.
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.render(renderContext);
        });
    },
    _openPage(pdfFile, pageNumber,zoom) {
      var parent = this
      pdfFile.getPage(this.currPageNumber).then(function(page) {
        console.log(vw+' x '+vh)
        console.log(typeof parent.viewport)
          if(parent.viewportSet == 0){
            var viewport = page.getViewport(1);
            parent.viewport = page.getViewport(1800/viewport.width);

            /*
            var vw = parent.viewport.width
            var vh = parent.viewport.height
            */
            var vw = parent.$el.clientWidth
            var vh = parent.$el.clientHeight 
            var Hvw = parent.$el.clientWidth
            var Hvh = parent.$el.clientHeight 
            var minScale = (vh/Hvh > vw/Hvw) ? Hvw/vw : Hvh/vh
            console.log(vw+' minscale ' +minScale)
            //parent.adjustScale = minScale
            //parent.currentStyle = 'position:abolute; transform-origin: left top;transform:scale('+minScale+') '


            console.log(parent.viewport)
          }  
          console.log("_____________---")    
          var canvas = document.getElementById('theCanvas')
          console.log(canvas)    
          var ctx = canvas.getContext('2d')
          console.log("_____________---")
          /*
          canvas.height = parent.viewport.height;
          canvas.width = parent.viewport.width;
          */
          canvas.height = parent.$el.clientHeight *2
          canvas.width = parent.$el.clientWidth*2
          var renderContext = {
              canvasContext: ctx,
              viewport: parent.viewport
          }
          
          page.render(renderContext)
          parent.loading = false
      })
    },



    handleResize(){
      //console.log(this.$refs.rmain.clientWidth)
      this.$teras.innerHeight =  window.innerHeight
      this.$teras.innerWidth = window.innerWidth

      this.openPage(this.doc,1, 1)

      /*
      console.log(this.$route.meta.device + " && " + this.$teras.device())
      if(this.$route.meta.device == 'mobile' && this.$teras.device()!='mobile'){
        console.log(this.$route.path.replace("-mobile", ""))
        this.$router.replace(this.$route.path.replace("-mobile", ""))
      }
      if(this.$route.meta.device != 'mobile' && this.$teras.device()=='mobile'){
        if(this.$route.path.toLowerCase().indexOf("-mobile") == -1)
        //this.$router.replace(this.$route.path.replace("-mobile", ""))
          this.$router.replace(this.$route.path+"-mobile")
      }
      */

      //this.larghezza = parseInt(this.$refs.app.clientWidth);
      console.log(this.$teras.width+ ' - ' +this.$teras.innerWidth)
      console.log(window.innerWidth)
      // console.log(document.documentElement.clientWidth)
    },
    




    handleCurrentChange(val) {
      this.currPageNumber = val;
      this.openPage(this.doc, this.currPageNumber, this.zoom);
      console.log(`current page: ${val}`);
    },
    pagePrev () {
      var pageNumber = Math.max(1, this.currPageNumber - 1);
      if (pageNumber !== this.currPageNumber) {
          this.currPageNumber = pageNumber;
          this.openPage(this.doc, this.currPageNumber);
      }
    },
    pageNext () {
      var pageNumber = Math.min(this.doc.numPages, this.currPageNumber + 1);
      if (pageNumber !== this.currPageNumber) {
        this.currPageNumber = pageNumber;
        this.openPage(this.doc, this.currPageNumber);
      }
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pdf-button{
    position:fixed;bottom:0;z-index:3;width: 100vw;height: 34px;background:#424F5C;
}.hammer-up {
  
    
    
    
   
    background:white;
}.hammer{
  height:600px;
    overflow-y:scroll;
  border:2px solid red;
}
</style>



// WEBPACK FOOTER //
// Pdf.vue?134c5d68